import { render, staticRenderFns } from "./changePsd.vue?vue&type=template&id=407c023c&scoped=true"
import script from "./changePsd.vue?vue&type=script&lang=js"
export * from "./changePsd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c023c",
  null
  
)

export default component.exports